<script lang="ts" setup>
import {useScreenSize} from "@/shared/composable/screensize.ts";
const screenSize = useScreenSize();
</script>
<template>
    <slot v-if="screenSize.isDesktop.value"/>
</template>